// extracted by mini-css-extract-plugin
export default {"container":"product-form_container__9H1y2","truncate-table":"product-form_truncate-table__1+gpy","table-text-faded":"product-form_table-text-faded__pkanI","form":"product-form_form__jFFLu","actions":"product-form_actions__FGvep","bottomBar":"product-form_bottomBar__+3Y-Y","bottomBarFixed":"product-form_bottomBarFixed__qvwQQ","seoDescription":"product-form_seoDescription__qSBsQ"};
    if(module.hot) {
      // 1793877076907
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  